export const DAO_CODE = 'INVOICE' + '_DAO';
